module.exports = __webpack_public_path__ + "static/img/ccmz-CyQYbsaT.05bf78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/ccmz-CyQYbsaT.png
// module id = vl1q
// module chunks = 16